import { render } from "./MiniRegistration.vue?vue&type=template&id=1153f9be"
import script from "./MiniRegistration.vue?vue&type=script&lang=js"
export * from "./MiniRegistration.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__